import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Iletisim() {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: 'Genel Bilgi',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    setIsVisible(true);
    
    // Update page title and meta
    document.title = "İletişim - 3D Print Pro | Ankara 3D Yazıcı Servisi";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Ankara\'da 3D yazıcı sorunlarınız için hemen iletişime geçin. Randevu alın, WhatsApp ile yazın veya telefon ile arayın. Hızlı çözüm garantisi.');
    }

    // Add Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "İletişim - 3D Print Pro",
      "description": "3D yazıcı sorunlarınız için hemen iletişime geçin",
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "3D Print Pro",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3",
          "addressLocality": "Yenimahalle",
          "addressRegion": "Ankara",
          "postalCode": "06480",
          "addressCountry": "TR"
        },
        "telephone": "+905414565635",
        "email": "info@3dprinterservis.com",
        "openingHours": ["Mo-Fr 09:00-18:00", "Sa 09:00-16:00"],
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+905414565635",
          "contactType": "customer service",
          "availableLanguage": "Turkish"
        }
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      formDataToSend.append('phone', formData.phone);
      formDataToSend.append('subject', formData.subject);
      formDataToSend.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d3jn7enuouli8ar1pdb0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', subject: 'Genel Bilgi', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <a 
                  href="https://3dprinterankara.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  SATIŞ
                </a>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className={`text-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              <span className="text-red-600">İletişim</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              3D yazıcı sorunlarınız için hemen iletişime geçin. Uzman ekibimiz size yardımcı olmaya hazır.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-8 mb-16">
            {[
              {
                icon: "ri-map-pin-line",
                title: "Adresimiz",
                info: "1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara",
                link: "https://maps.google.com/?q=1459.+Cad,+İvedik+OSB+Özanadolu+Sanayi+Sitesi+No:3,+06480+Yenimahalle/Ankara"
              },
              {
                icon: "ri-phone-line",
                title: "Telefon",
                info: "0541 456 56 35",
                link: "tel:05414565635"
              },
              {
                icon: "ri-mail-line",
                title: "E-posta",
                info: "info@3dprinterservis.com",
                link: "mailto:info@3dprinterservis.com"
              }
            ].map((contact, index) => (
              <div 
                key={index}
                className={`text-center p-8 bg-gray-50 rounded-xl hover:shadow-lg transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${200 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${contact.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{contact.title}</h3>
                <a 
                  href={contact.link}
                  target={contact.link.startsWith('http') ? '_blank' : '_self'}
                  rel={contact.link.startsWith('http') ? 'noopener noreferrer' : ''}
                  className="text-gray-600 hover:text-red-600 transition-colors"
                >
                  {contact.info}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form & Map */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div className={`transition-all duration-1000 delay-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Bize Ulaşın</h2>
                
                {submitStatus === 'success' && (
                  <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                    Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                    Bir hata oluştu. Lütfen tekrar deneyin veya telefon ile iletişime geçin.
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form id="iletisim-formu">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Ad Soyad *
                      </label>
                      <input 
                        type="text" 
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-5…"
                        placeholder="Adınızı ve soyadınızı girin"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        E-posta *
                      </label>
                      <input 
                        type="email" 
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-5…"
                        placeholder="E-posta adresinizi girin"
                      />
                    </div>
                  </div>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Telefon *
                      </label>
                      <input 
                        type="tel" 
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-5…"
                        placeholder="Telefon numaranızı girin"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Konu
                      </label>
                      <select 
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-5… pr-8 text-sm"
                      >
                        <option value="Genel Bilgi">Genel Bilgi</option>
                        <option value="Tamir">Tamir</option>
                        <option value="Bakım">Bakım</option>
                        <option value="Kurulum">Kurulum</option>
                        <option value="Randevu">Randevu</option>
                        <option value="Diğer">Diğer</option>
                      </select>
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Mesajınız *
                    </label>
                    <textarea 
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      rows={6}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-5…"
                      placeholder="Mesajınızı yazın (maksimum 500 karakter)"
                    ></textarea>
                    <div className="text-xs text-gray-500 mt-1">
                      {formData.message.length}/500 karakter
                    </div>
                  </div>
                  
                  <button 
                    type="submit"
                    disabled={isSubmitting || formData.message.length > 500}
                    className="w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-400 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer"
                  >
                    {isSubmitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                  </button>
                </form>
              </div>
            </div>

            {/* Map */}
            <div className={`transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full">
                <div className="p-6 border-b border-gray-200">
                  <h3 className="text-2xl font-bold text-gray-900">Konumumuz</h3>
                  <p className="text-gray-600 mt-2">
                    İvedik OSB'de modern atölyemizde hizmet veriyoruz
                  </p>
                </div>
                <div className="h-96">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.7234567890123!2d32.7371379!3d39.988999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d34a21679c5951%3A0x194bdc5a3416e1f8!2s1459.%20Cad%2C%20%C4%B0vedik%20OSB%20%C3%96zanadolu%20Sanayi%20Sitesi%20No%3A3%2C%2006480%20Yenimahalle%2FAnkara!5e0!3m2!1str!2str!4v1760000510377!5m2!1str!2str"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="3D Print Pro Konum"
                  ></iframe>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Quick Contact */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Hızlı İletişim
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Acil durumlar için hemen iletişime geçin
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <a 
              href="tel:03123945635"
              className={`bg-red-600 hover:bg-red-700 text-white p-8 rounded-xl text-center transition-all duration-300 hover:scale-105 cursor-pointer ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: '700ms' }}
            >
              <i className="ri-phone-line text-4xl mb-4"></i>
              <h3 className="text-xl font-bold mb-2">Hemen Ara</h3>
              <p className="text-red-100">0312 394 56 35</p>
            </a>

            <a 
              href="https://wa.me/903123945635"
              target="_blank"
              rel="noopener noreferrer"
              className={`bg-green-600 hover:bg-green-700 text-white p-8 rounded-xl text-center transition-all duration-300 hover:scale-105 cursor-pointer ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: '800ms' }}
            >
              <i className="ri-whatsapp-line text-4xl mb-4"></i>
              <h3 className="text-xl font-bold mb-2">WhatsApp</h3>
              <p className="text-green-100">Mesaj Gönder</p>
            </a>

            <a 
              href="mailto:info@3dprinterservis.com"
              className={`bg-blue-600 hover:bg-blue-700 text-white p-8 rounded-xl text-center transition-all duration-300 hover:scale-105 cursor-pointer ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: '900ms' }}
            >
              <i className="ri-mail-line text-4xl mb-4"></i>
              <h3 className="text-xl font-bold mb-2">E-posta</h3>
              <p className="text-blue-100">E-posta Gönder</p>
            </a>
          </div>
        </div>
      </section>

      {/* Working Hours */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Çalışma Saatleri
            </h2>
            <p className="text-xl text-gray-600">
              Size en iyi hizmeti verebilmek için geniş çalışma saatleri
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Hafta İçi</h3>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Pazartesi - Cuma</span>
                    <span className="font-medium text-gray-900">09:00 - 18:00</span>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Hafta Sonu</h3>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Cumartesi</span>
                    <span className="font-medium text-gray-900">09:00 - 16:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Pazar</span>
                    <span className="font-medium text-red-600">Kapalı</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-8 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
                <li><Link to="/hizmetler" className="hover:text-white transition-colors">Tüm Hizmetler</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
                <li><a href="#" className="hover:text-white transition-colors">Referanslar</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0312 394 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır. | 
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
